var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M83.417,18.329c0-0.002,0.001-0.003,0.001-0.005c0-0.853-0.69-1.544-1.542-1.545v-0.016H61.078v0.017 c-0.846,0.008-1.53,0.695-1.53,1.543v6.871h0l0,0c0,0.847,0.684,1.534,1.53,1.542v0.001h5.151l-8.713,8.713 c-4.202-2.875-9.284-4.56-14.761-4.56c-14.455,0-26.173,11.718-26.173,26.173s11.718,26.174,26.173,26.174 c14.455,0,26.173-11.719,26.173-26.174c0-5.373-1.621-10.366-4.398-14.521l8.911-8.911v5.473c0,0.853,0.691,1.544,1.544,1.544 h6.887c0.852,0,1.544-0.691,1.544-1.544c0-0.002-0.001-0.003-0.001-0.005V18.329z M42.755,73.262 c-8.946,0-16.198-7.252-16.198-16.199c0-8.946,7.252-16.199,16.198-16.199s16.199,7.253,16.199,16.199 C58.954,66.01,51.701,73.262,42.755,73.262z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.d4e2f78b94d920fc5bc69905aff7091d.svg";
export { ForwardRef as ReactComponent };